export default "__VITE_ASSET__98c560fb__"